<template>
    <ul class="lot-list">
        <li v-for="(g,i) in goodsList" :key="i" @click="$router.push({ path: `/goods/detail/${g.id}`})">
            <div class="img">
                <el-image class="log" :src="$common.imgPath(g.goodsLog)" :alt="g.id" lazy fit="cover"></el-image>
                <img v-if="g.goodsVideo&&g.goodsType==2" src="../../assets/images/icons/icon_video_play.png" alt="" class="btn-play">
            </div>
            <p class="time" :style="g.goodsType==3||g.goodsType==2?'opacity:1':'opacity:0'"><i class="el-icon-time"></i>
                距离结束
               <timeCounter :nowTime="nowTime" :endTime="g.overTime"></timeCounter>
            </p>
            <p class="name">{{g.goodsName}}</p>
            <div class="price"><div class="fl price-txt"><span class="flag">¥</span>{{g.price}}</div><button type="button" class="fr btn-price">{{g.goodsType==3?'出价':g.goodsType==2?'出价':'购买'}}</button></div>
        </li>
    </ul>
</template>
<script>
    import timeCounter from '../../components/timeCounter'
    export default {
        props:{
            goodsList:[Array],
            nowTime:[String]
        },
        data(){
            return {
                countDownInterval:null,
                day: '0',
                hour: '00',
                min: '00',
                second: '00',
            }
        },
        components:{
            timeCounter
        },
        computed:{
            serveTime(){
                return this.nowTime.getTime();
            },

        },
        mounted(){
            //console.log("overTime",this.overTime)
            //this.countdown();
        },
        methods:{
            //倒计时
            countdown(endTime) {
                const end = Date.parse(endTime);
                const now = Date.parse(this.nowTime);
                const msec = end - now;
                if (msec >= 0) {
                    let day = parseInt(msec / 1000 / 60 / 60 / 24);
                    let hr = parseInt(msec / 1000 / 60 / 60 % 24);
                    let min = parseInt(msec / 1000 / 60 % 60);
                    let sec = parseInt(msec / 1000 % 60);
                    this.day = day;
                    this.hr = hr > 9 ? hr : '0' + hr;
                    this.min = min > 9 ? min : '0' + min;
                    this.sec = sec > 9 ? sec : '0' + sec;
                }
                const that = this;
                this.countDownInterval=setInterval(function () {
                    this.nowTime=this.nowTime-1000;
                    that.countdown()
                }, 1000)
            },
        },
        //当离开页面时，清除倒计时
        beforeDestroy() {
            clearInterval(this.countDownInterval)
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../assets/css/common';
    .lot-list{
        padding-bottom:20px;
        overflow: hidden;
        li{
            margin-top:20px;
            margin-right:20px;
            border-radius: 10px;
            &:nth-child(4n){margin-right:0;}
            float: left;
            width:285px;
            height:400px;
            background-color: #ffffff;
            .img{
                width:240px;height:240px;margin:0 auto 10px;padding-top:28px;
                overflow: hidden;
                position: relative;
                .log{width:100%;height:100%;object-fit: cover;
                    position: absolute;
                    top:0;
                    left:0;
                    z-index: 1;
                }
                .btn-play{
                    position: absolute;
                    top:50%;
                    left: 50%;
                    width: 58px;
                    height: 70px;
                    margin-left: -29px;
                    margin-top: -35px;
                    z-index: 2;
                }
            }
            .time{font-size:12px;color:#6F6F6F;margin-top:12px;margin-left:22px;}
            .name{font-size:14px;color:#6F6F6F;margin-left:22px;margin-top:10px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;}
            .price{
                margin:35px 20px 18px 22px;
                font-size:14px;
                overflow: hidden;
                .price-txt{color:$main-color;font-size:22px;
                    .flag{font-size:14px;}
                }
                .btn-price{width:126px;height:29px;
                    line-height:29px;color:#ffffff;background-color:$main-color;
                    -webkit-border-radius: 4px;
                    -moz-border-radius: 4px;
                    border-radius: 4px;}
            }
        }
    }

</style>